'use strict';
// write code here
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    var inputName = input.getAttribute('name');
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    label.textContent = inputName;
    var capitalizedName = inputName.charAt(0).toUpperCase() + inputName.slice(1);
    input.setAttribute('placeholder', capitalizedName);
    input.parentElement.append(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.952aca70.js.map
